import { atom } from 'recoil';

export const isNewCashDisbursedModalOpenAtom = atom<boolean>({
  key: 'isNewCashDisbursedOpen',
  default: false,
});
